import { drawDensity } from '../drawDensity';
import WiggleBaseRenderer from '../WiggleBaseRenderer';
export default class DensityRenderer extends WiggleBaseRenderer {
    async draw(ctx, props) {
        return drawDensity(ctx, props);
    }
}
